// Tiny i18n core (no dependency). English is the default language AND the key: t('Create issue') returns the
// English text unless the active language has a translation for exactly that string. A missing translation
// therefore degrades to readable English instead of breaking the screen.
import moment from 'moment';
import 'moment/locale/he';
import 'moment/locale/es';
import he from './locales/he.json';
import es from './locales/es.json';

export const LANGS = [
  { code: 'en', native: 'English', dir: 'ltr' },
  { code: 'he', native: 'עברית', dir: 'rtl' },
  { code: 'es', native: 'Español', dir: 'ltr' },
];
const catalogs = { en: {}, he, es };
const KEY = 'gq-lang';

const read = () => {
  try {
    const v = localStorage.getItem(KEY);
    return LANGS.some((l) => l.code === v) ? v : 'en';
  } catch (e) {
    return 'en';
  }
};

let current = read();

/** apply language to the document: text direction, <html lang>, and the date library */
export function applyLang(code = current) {
  const l = LANGS.find((x) => x.code === code) || LANGS[0];
  current = l.code;
  if (typeof document !== 'undefined') {
    document.documentElement.lang = l.code;
    document.documentElement.dir = l.dir;
  }
  moment.locale(l.code);
  return l;
}
applyLang(current);

export const getLang = () => current;
export const isRtl = () => (LANGS.find((l) => l.code === current) || LANGS[0]).dir === 'rtl';
export function setLang(code) {
  try {
    localStorage.setItem(KEY, code);
  } catch (e) {
    /* storage unavailable: the choice just lasts for this visit */
  }
  return applyLang(code);
}

const fill = (s, params) => (params ? s.replace(/\{\{\s*(\w+)\s*\}\}/g, (m, k) => (params[k] === undefined || params[k] === null ? '' : params[k])) : s);

/** translate `key` (the English text); `{{name}}` placeholders are filled from `params` */
export function t(key, params) {
  if (typeof key !== 'string') return key;
  const cat = catalogs[current];
  const hit = cat && cat[key];
  return fill(hit === undefined || hit === '' ? key : hit, params);
}

/** plural: tn(3, '{{count}} member', '{{count}} members') */
export const tn = (n, one, other, params) => t(Number(n) === 1 ? one : other, { count: n, ...params });

/** "a – b" (times, dates) kept in reading order inside right-to-left text. */
export const rng = (a, b) => `\u2066${a} – ${b}\u2069`;
